import { autorun } from "mobx";

export default class BaseStore {
  protected StoreName: string = "";

  constructor(storeName: string) {
    this.StoreName = storeName;
    autorun(() => {});
  }
}



// WEBPACK FOOTER //
// ./src/common/BaseStore.ts